// extracted by mini-css-extract-plugin
module.exports = {"additionalInfo":"registration-link_additionalInfo__sf_Em","link":"registration-link_link__mJu5B"};